import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogContent: {
    overflow: 'visible',
  },
  dialogPaper: {
    overflow: 'visible',
    margin: 'auto',
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  characterCounter: {},
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
    },
  },
  fieldset: {
    width: '100%',
  },
  spacer: {
    marginTop: '24px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  radioButton: {
    width: '100%',
    alignItems: 'flex-start',
    '& .MuiFormControlLabel-label': { width: '100%' },
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  locationSelectContainer: {
    paddingTop: '8px',
    width: '100%',
  },
  errorMsg: {
    marginTop: '8px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
